var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError, resolveQueryFieldsTransformationPaths, } from '@wix/metro-runtime/velo';
import * as ambassadorWixEventsGuestsV1Guest from '@wix/ambassador-events-guests-v1-guest/http';
// @ts-ignore
import { wrapWithQueryBuilder } from '@wix/motion-edm-autogen-query-wrapper';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var SubdivisionType;
(function (SubdivisionType) {
    SubdivisionType["UNKNOWN_SUBDIVISION_TYPE"] = "UNKNOWN_SUBDIVISION_TYPE";
    /** State */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_1"] = "ADMINISTRATIVE_AREA_LEVEL_1";
    /** County */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_2"] = "ADMINISTRATIVE_AREA_LEVEL_2";
    /** City/town */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_3"] = "ADMINISTRATIVE_AREA_LEVEL_3";
    /** Neighborhood/quarter */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_4"] = "ADMINISTRATIVE_AREA_LEVEL_4";
    /** Street/block */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_5"] = "ADMINISTRATIVE_AREA_LEVEL_5";
    /** ADMINISTRATIVE_AREA_LEVEL_0. Indicates the national political entity, and is typically the highest order type returned by the Geocoder. */
    SubdivisionType["COUNTRY"] = "COUNTRY";
})(SubdivisionType || (SubdivisionType = {}));
export var AttendanceStatus;
(function (AttendanceStatus) {
    /** Not attending. */
    AttendanceStatus["NOT_ATTENDING"] = "NOT_ATTENDING";
    /** Attending. */
    AttendanceStatus["ATTENDING"] = "ATTENDING";
    /** In a waiting list. */
    AttendanceStatus["IN_WAITLIST"] = "IN_WAITLIST";
})(AttendanceStatus || (AttendanceStatus = {}));
export var GuestType;
(function (GuestType) {
    /** Rsvp guest. */
    GuestType["RSVP"] = "RSVP";
    /** Buyer guest. */
    GuestType["BUYER"] = "BUYER";
    /** Ticket holder guest. */
    GuestType["TICKET_HOLDER"] = "TICKET_HOLDER";
})(GuestType || (GuestType = {}));
export var MemberEventStatusUpdatedEventType;
(function (MemberEventStatusUpdatedEventType) {
    /**
     * Every time a guest with specified member ID is added to the event.
     * This event can also be fired if existing guest changed member ID.
     */
    MemberEventStatusUpdatedEventType["MEMBER_JOINED"] = "MEMBER_JOINED";
    /**
     * Every time a guest with specified member ID is removed from the event.
     * This event can also be fired if existing guest changed member ID.
     */
    MemberEventStatusUpdatedEventType["MEMBER_LEFT"] = "MEMBER_LEFT";
    /**
     * Every time a guest with specified member ID and status ATTENDING is added to the event.
     * This event can also be fired if existing guest changed member ID or status to ATTENDING.
     */
    MemberEventStatusUpdatedEventType["ATTENDING_MEMBER_JOINED"] = "ATTENDING_MEMBER_JOINED";
    /**
     * Once last guest with specified member ID is removed from the event or status became not ATTENDING.
     * Once this is fired there are no more attending guests with specified member ID in the event.
     * This event can also be fired if existing guest changed their member ID or status to not ATTENDING.
     */
    MemberEventStatusUpdatedEventType["LAST_ATTENDING_MEMBER_LEFT"] = "LAST_ATTENDING_MEMBER_LEFT";
})(MemberEventStatusUpdatedEventType || (MemberEventStatusUpdatedEventType = {}));
export var EventType;
(function (EventType) {
    /**
     * Every time a guest with specified contact ID is added to the event.
     * This event can also be fired if existing guest changed contact ID.
     */
    EventType["CONTACT_JOINED"] = "CONTACT_JOINED";
    /**
     * Every time a guest with specified contact ID is removed from the event.
     * This event can also be fired if existing guest changed contact ID.
     */
    EventType["CONTACT_LEFT"] = "CONTACT_LEFT";
    /**
     * Once last guest with specified contact ID is removed from the event.
     * Once this is fired there are no more guests with specified contact ID in the event.
     * This event can also be fired if existing guest changed their contact ID.
     */
    EventType["LAST_CONTACT_LEFT"] = "LAST_CONTACT_LEFT";
})(EventType || (EventType = {}));
export var NotifyActionType;
(function (NotifyActionType) {
    NotifyActionType["UNKNOWN"] = "UNKNOWN";
    NotifyActionType["EMAIL"] = "EMAIL";
    NotifyActionType["AUTOMATION_TRIGGER"] = "AUTOMATION_TRIGGER";
    NotifyActionType["PUSH"] = "PUSH";
})(NotifyActionType || (NotifyActionType = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var RequestedFieldsEnumRequestedFields;
(function (RequestedFieldsEnumRequestedFields) {
    RequestedFieldsEnumRequestedFields["UNKNOWN_REQUESTED_FIELD"] = "UNKNOWN_REQUESTED_FIELD";
    /** Select fields: `guestDetails` and `tickets`. */
    RequestedFieldsEnumRequestedFields["GUEST_DETAILS"] = "GUEST_DETAILS";
    /** Returns queried guests total */
    RequestedFieldsEnumRequestedFields["GUEST_TOTAL"] = "GUEST_TOTAL";
})(RequestedFieldsEnumRequestedFields || (RequestedFieldsEnumRequestedFields = {}));
export var RsvpStatus;
(function (RsvpStatus) {
    RsvpStatus["YES"] = "YES";
    RsvpStatus["NO"] = "NO";
    RsvpStatus["WAITING"] = "WAITING";
})(RsvpStatus || (RsvpStatus = {}));
export var OrderStatus;
(function (OrderStatus) {
    /** Order status not available for this request fieldset */
    OrderStatus["NA_ORDER_STATUS"] = "NA_ORDER_STATUS";
    /** Order is confirmed, no payment required */
    OrderStatus["FREE"] = "FREE";
    /** Order was paid but payment gateway suspended the payment. Eventually changes to PAID */
    OrderStatus["PENDING"] = "PENDING";
    /** Order paid via payment gateway */
    OrderStatus["PAID"] = "PAID";
    /** Order confirmed but has to be paid via offline payment and status manually updated to PAID */
    OrderStatus["OFFLINE_PENDING"] = "OFFLINE_PENDING";
    /** Order is awaiting for payment in Cashier */
    OrderStatus["INITIATED"] = "INITIATED";
    /** Order was canceled */
    OrderStatus["CANCELED"] = "CANCELED";
    /** Order payment was declined */
    OrderStatus["DECLINED"] = "DECLINED";
})(OrderStatus || (OrderStatus = {}));
export var TaxType;
(function (TaxType) {
    /** Tax is included in the ticket price */
    TaxType["INCLUDED"] = "INCLUDED";
    /** Tax is added to the order at the checkout */
    TaxType["ADDED"] = "ADDED";
    /** Tax is added to the final total at the checkout */
    TaxType["ADDED_AT_CHECKOUT"] = "ADDED_AT_CHECKOUT";
})(TaxType || (TaxType = {}));
export var FeeName;
(function (FeeName) {
    /** Wix service fee charges applied to the line item. */
    FeeName["WIX_FEE"] = "WIX_FEE";
})(FeeName || (FeeName = {}));
export var FeeType;
(function (FeeType) {
    /** Fee is added to the ticket price at checkout */
    FeeType["FEE_ADDED"] = "FEE_ADDED";
    /** Seller absorbs the fee. It is deducted from the ticket price */
    FeeType["FEE_INCLUDED"] = "FEE_INCLUDED";
    /** Fee is added to the ticket price at checkout */
    FeeType["FEE_ADDED_AT_CHECKOUT"] = "FEE_ADDED_AT_CHECKOUT";
})(FeeType || (FeeType = {}));
export var OrderType;
(function (OrderType) {
    /** Buyer form is used for all tickets */
    OrderType["UNASSIGNED_TICKETS"] = "UNASSIGNED_TICKETS";
    /** Each order ticket has its own form */
    OrderType["ASSIGNED_TICKETS"] = "ASSIGNED_TICKETS";
})(OrderType || (OrderType = {}));
export var RequestedFields;
(function (RequestedFields) {
    /** Unknown requested field. */
    RequestedFields["UNKNOWN_REQUESTED_FIELD"] = "UNKNOWN_REQUESTED_FIELD";
    /** Member guests. */
    RequestedFields["MEMBER_GUESTS"] = "MEMBER_GUESTS";
    /** Waitlist count. */
    RequestedFields["WAITLIST_COUNT"] = "WAITLIST_COUNT";
})(RequestedFields || (RequestedFields = {}));
const _eventGuest = { guestDetails: '_guestDetails' };
const _eventGuests = { guests: '_eventGuest' };
const _formattedAddress = { address: 'wix.common.Address' };
const _formResponse = { inputValues: '_inputValue' };
const _guestDetails = { formResponse: '_formResponse' };
const _guestListPreview = { latestAttendingMembers: '_eventGuests' };
const _inputValue = { address: '_formattedAddress' };
const _listGuestListPreviewsRequest = {};
const _listGuestListPreviewsResponse = { previews: '_guestListPreview' };
const _queryEventGuestsRequest = {};
const _queryEventGuestsResponse = { guests: '_eventGuest' };
/**
 * Creates a query to retrieve a list of guests.
 *
 *
 * The `queryGuests()` function builds a query to retrieve a list of guests and returns a [GuestsQueryBuilder](https://www.wix.com/velo/reference/wix-events-v2/guests/guestsquerybuilder) object.
 *
 * The returned object contains the query definition which is typically used to run the query using the `find()` function.
 *
 * You can refine the query by chaining `GuestsQueryBuilder` functions onto the query. `GuestsQueryBuilder` functions enable you to sort, filter, and control the results that `queryGuests.find()` returns.
 *
 * The query runs with the following `GuestsQueryBuilder` defaults that you can override:
 *
 * - [`skip(0)`](https://www.wix.com/velo/reference/wix-events-v2/guests/guestsquerybuilder/skipto)
 * - [`limit(50)`](https://www.wix.com/velo/reference/wix-events-v2/guests/guestsquerybuilder/limit)
 * - [`descending("_createdDate")`](https://www.wix.com/velo/reference/wix-events-v2/guests/guestsquerybuilder/descending)
 *
 * The functions that are chained to `queryGuests()` are applied in the order they are called. For example, if you apply `ascending ('_createdDate')` and then `descending ('_updatedDate')`, the results are sorted first by the created date and then, if there are multiple results with the same date, the items are sorted by the updated date.
 *
 * The table below shows which `GuestsQueryBuilder` functions are supported for `queryGuests()`. You can only use one filter function for each property. Only the first filter will work if a property is used in more than one filter.
 * @public
 * @permissionId WIX_EVENTS.READ_GUESTS
 * @adminMethod
 */
export function queryGuests(options) {
    const requestTransformation = { '*': '$[1]', query: '$[0]' };
    const responseTransformation = {
        items: '$.guests',
        pagingMetadata: '$.pagingMetadata',
    };
    // @ts-ignore
    const { httpClient, sideEffects, additionalHeaders } = arguments[1];
    const { toAmbassadorRequest } = serializer({
        rootSchema: _queryEventGuestsRequest,
        depSchemas: {},
        fqdnTransformation: {
            paths: [],
            transformation: _fromVeloEntity,
        },
        customTransformation: requestTransformation,
    });
    const { fromJSON } = serializer({
        rootSchema: _queryEventGuestsResponse,
        depSchemas: {
            _eventGuest,
            _formResponse,
            _formattedAddress,
            _guestDetails,
            _inputValue,
        },
        fqdnTransformation: {
            paths: [...['Array#guests']],
            transformation: _toVeloEntity,
        },
        customTransformation: responseTransformation,
    });
    return wrapWithQueryBuilder({
        func: (payload) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const reqOpts = ambassadorWixEventsGuestsV1Guest.queryEventGuests(Object.assign(Object.assign({}, payload), (options !== null && options !== void 0 ? options : {})));
            const reqOptionWithHeadersWrapper = (args) => {
                const result = reqOpts(args);
                if (additionalHeaders) {
                    const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                    return Object.assign(Object.assign({}, result), { headers });
                }
                return result;
            };
            (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
            try {
                const result = yield httpClient.request(reqOptionWithHeadersWrapper);
                (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
                return result;
            }
            catch (err) {
                (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
                throw err;
            }
        }),
        requestTransformer: (...args) => toAmbassadorRequest(args),
        responseTransformer: ({ data }) => fromJSON(data),
        errorTransformer: (err) => {
            const transformedError = transformError(err, requestTransformation);
            throw transformedError;
        },
        pagingMethod: 'CURSOR',
        transformationPaths: resolveQueryFieldsTransformationPaths(_toVeloEntity),
    })({ cursorWithEmptyFilterAndSort: true });
}
/**
 * Returns a list of guest list summaries per event.
 * @param eventIds - Event ids.
 * @internal
 * @documentationMaturity preview
 * @requiredField eventIds
 * @adminMethod
 */
export function listGuestListPreviews(eventIds, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            eventIds: '$[0]',
            cursorPaging: '$[1].cursorPaging',
            fields: '$[1].fields',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listGuestListPreviewsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listGuestListPreviewsResponse,
            depSchemas: {
                _eventGuest,
                _eventGuests,
                _formResponse,
                _formattedAddress,
                _guestDetails,
                _guestListPreview,
                _inputValue,
            },
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([eventIds, options]);
        const reqOpts = ambassadorWixEventsGuestsV1Guest.listGuestListPreviews(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'eventIds',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=events-guests-v1-guest.universal.js.map